import { api } from './client'
import type { LatLng } from '@/components/growers/area-map/use-area-polygon'

/**
 * Một thửa trên màn bản đồ vùng trồng chung — đủ để vẽ polygon và nhãn
 * "tên hộ / tên vùng". Cố ý KHÔNG có CCCD, ngân hàng, địa chỉ của hộ.
 */
export interface AreaMapItem {
    area_id: string
    code: string
    name: string
    acreage: number
    grower_id: string
    grower_name: string
    grower_nickname?: string | null
    paths: LatLng[]
}

/**
 * Khung bao của toàn bộ thửa đã khoanh + `focus` = tâm thửa gần tâm khung bao
 * nhất (điểm bản đồ zoom vào khi mở). `count = 0` thì tất cả null.
 */
export interface AreaMapExtent {
    count: number
    min_lat: number | null
    max_lat: number | null
    min_lng: number | null
    max_lng: number | null
    focus_lat: number | null
    focus_lng: number | null
}

export interface AreaMapBBox {
    min_lat: number
    max_lat: number
    min_lng: number
    max_lng: number
}

export const growerAreaMapApi = {
    /** Không truyền bbox = lấy tất cả thửa đã khoanh. */
    list: (bbox?: AreaMapBBox) =>
        api.get<AreaMapItem[]>('/grower-areas/map', {
            params: bbox as unknown as Record<string, number> | undefined,
        }),
    extent: () => api.get<AreaMapExtent>('/grower-areas/map/extent'),
}
